import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import sk from './locales/sk.json';

const LANG_KEY = 'lang';
const SUPPORTED = ['en', 'sk'] as const;
type Lang = (typeof SUPPORTED)[number];

const stored = localStorage.getItem(LANG_KEY);
const initialLang: Lang = SUPPORTED.includes(stored as Lang) ? (stored as Lang) : 'en';

document.documentElement.lang = initialLang;

void i18n.use(initReactI18next).init({
  lng: initialLang,
  fallbackLng: 'en',
  resources: {
    en: { translation: en },
    sk: { translation: sk }
  },
  interpolation: {
    escapeValue: false // React already escapes values
  }
});

i18n.on('languageChanged', (lang) => {
  document.documentElement.lang = lang;
});

export default i18n;
